<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.push('/settings')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-menu v-if="client" v-model="menu_status" offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                <span class="ml-7">CY {{selectedFiscalYear}}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Caledar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate height="2" class="mt-0"></v-progress-linear>
            </v-card>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="rounded-4 mt-7">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert> 

            <!-- CLIENT DETAILS -->
            <v-card class="elevation-1 mt-5" v-if="!loading">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold primary--text">CLIENT DETAILS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="client" icon @click="showEditClient" title="Edit Client Details">
                        <v-icon color="primary" small>edit</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>

                    <!-- CLIENT DATA FOUND -->
                    <v-layout row wrap v-if="client" :class="isMobile?'':'section-layout'">
                        <v-flex xs12 sm6>
                            <div class="caption grey--text text--darken-1">Client Name</div>
                            <div class="text--darken-2 font-weight-bold">
                                {{ client.clientName }}
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <div class="caption grey--text text--darken-1">Base Currency</div>
                            <div class="font-weight-bold">
                                <v-chip class="chip--select-multi">
                                    <v-avatar size="24">
                                        <v-img :src="getCurrencyAvatar(client.defaultCurrency)" contain></v-img>
                                    </v-avatar>
                                    {{ client.defaultCurrency }}
                                </v-chip>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="client.contactPerson">
                            <div class="caption grey--text text--darken-1">Contact Person</div>
                            <div>
                                {{ client.contactPerson }}
                            </div>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="client.contactEmail">
                            <div class="caption grey--text text--darken-1">Contact Email</div>
                            <div>
                                {{ client.contactEmail }}
                            </div>
                        </v-flex>
                    </v-layout>

                    <!-- CLIENT DATA NOT FOUND -->
                    <v-layout row wrap v-else>
                        <v-flex xs12>
                            <div class="ml-10">
                                Define your client’s base currency and configure exchange rates per cutoff to enable multi‑currency payroll processing.
                            </div>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn flat class="primary no-uppercase" @click="showEditClient">Set Up Forex</v-btn>
                        </v-flex>
                    </v-layout>

                </v-card-text>

            </v-card>

            <!-- EXCHANGE RATES PER CUTOFF -->
            <v-card v-if="client" class="elevation-1 mt-5">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold primary--text">CUTOFF EXCHANGE RATES</span>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-data-table
                    :headers="isMobile ? [] : header"
                    :items="forexSettingsFiltered"
                    :loading="loading"  
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="header.length" class="pa-1">
                                <v-card class="elevation-1">
                                    <v-toolbar flat height="42">
                                        <b>{{ props.item.cutoffStart | moment("MMM DD") }} - {{ props.item.cutoffEnd | moment("DD, YYYY") }}</b>
                                        <v-spacer></v-spacer>
                                        <v-menu left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                                    <v-icon small>more_vert</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-tile v-show="hasEditRights" @click="showEditExchangeRate(props.item)">
                                                    <v-list-tile-title>Set Exchange Rate</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Cutoff Status</div>
                                                    <b :class="commonfn.getStatusColor(props.item.cutoffStatus)">{{commonfn.getStatusDescription(props.item.cutoffStatus)}}</b>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Base Currency</div>
                                                    <div>{{ props.item.baseCurrency }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Target Currency</div>
                                                    <div>{{ props.item.targetCurrency }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                 <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Exchange Rate</div>
                                                    <div v-if="props.item.exchangeRate>0">{{ Number(props.item.exchangeRate).toFixed(6) }}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else>
                            <td>{{ props.item.cutoffStart | moment("YYYY-MM-DD") }}</td>
                            <td>{{ props.item.cutoffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutoffStatus)">{{commonfn.getStatusDescription(props.item.cutoffStatus)}}</b>
                            </td>
                            <td>{{ props.item.baseCurrency }}</td>
                            <td>{{ props.item.targetCurrency }}</td>
                            <td>
                                <span v-if="props.item.exchangeRate>0">{{ Number(props.item.exchangeRate).toFixed(6) }}</span>
                            </td>
                            <td>
                                <v-menu left offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                            <v-icon small>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-tile v-show="hasEditRights" @click="showEditExchangeRate(props.item)">
                                            <v-list-tile-title>Set Exchange Rate</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                        
                    </template>
                </v-data-table>

            </v-card>

            <!-- Comments and Updates -->
            <v-layout v-if="client" row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogEditClient" width="600" persistent>   
            <edit-client ref="editClientRef" :dialogEditClient.sync="dialogEditClient" @send="getClientDetails(false)"></edit-client>
        </v-dialog>
        <v-dialog v-model="dialogEditExchangeRate" width="600" persistent>   
            <edit-exchange-rate ref="editExchangeRateRef" :dialogEditExchangeRate.sync="dialogEditExchangeRate" @send="getClientDetails(false)"></edit-exchange-rate>
        </v-dialog>

        <!-- Status messaging component. For Refactor - convert this to js script only -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import clientApi from '@/api/client'
import commonfn from '@/common/functions'   //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import { getCurrencyAvatar } from '@/constants/default-currencies'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort, getCalendarYear, updateCalendarYear } from '@/helpers/user-prefs'
import { hasEditRights } from '@/helpers/access-permissions'

export default {     
    name: 'Forex',
    metaInfo: {
        title: 'Forex',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Manage base currency and exchange rates per cutoff.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'edit-client': () => import('@/components/Client/EditClient'),
        'edit-exchange-rate': () => import('@/components/Client/EditExchangeRate'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            selectedFiscalYear: getCalendarYear(this.$route.name),
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header: [
                {text: 'Cutoff Start Date',align: 'left',value: 'cutoffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutoffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutoffStatus',  width: '10%', sortable:true},
                {text: 'Base Currency',align: 'left',value: 'baseCurrency',  width: '10%', sortable:true},
                {text: 'Target Currency',align: 'left',value: 'targetCurrency',  width: '10%', sortable:true},
                {text: 'Exchange Rate',align: 'left',value: 'exchangeRate',  width: '10%', sortable:true},
                {text: 'Action',align: 'left',value: 'exchangeRate',  width: '5%', sortable:false},
            ],
            menu_status: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_action: [],
            dialogEditClient: false,
            dialogEditExchangeRate: false,
            client: null,
            forexSettings: []
        }
    },
    methods: {
        getCurrencyAvatar,
        showEditExchangeRate(data) {
            this.$refs.editExchangeRateRef.setEdit(data, this.client)
            this.dialogEditExchangeRate = true
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            updateCalendarYear(this.$route.name, fiscalYear)
        },
        showEditClient() {
            this.$refs.editClientRef.setEdit(this.client)
            this.dialogEditClient = true
        },
        async getClientDetails(show_loading) {
            try {
                this.loading = show_loading
                const response = await clientApi.get()
                if (response && response.status == 200) {
                    this.client = response.data.client
                    this.forexSettings = response.data.forexSettings
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) {
                await this.getClientDetails(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Forex'
        })

        this.getClientDetails(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        pageQueryId() {
            return this.client ? this.client.clientId : ''
        },
        commentsData() {
            return {
                pageQueryId: this.pageQueryId,
                
                //these are used to notify other users when adding comment
                //this is for refactor. see dev tasks.
                pageItemCreatedBy: null,
                pageLink: null,
                pageKey: null,
                notificationTypeId: null,
            }
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        forexSettingsFiltered() {
            var temp = this.forexSettings.filter(item => {
                return (item.fiscalYear == this.selectedFiscalYear)
            })
            return temp
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>